module.exports = __webpack_public_path__ + "static/media/leather-armor.f3d5462f.svg";